<template>
    <div id="app-header" class="container-size-fixer">
        <!--<div v-if="windowWidth > 1300 || $store.state.authenticationPage"-->
             <!--v-on:click="$router.push('/')" class="app-header-section clearfix" id="header-logo">-->
            <!--<img width="70" height="70" src="../assets/appIcons/Pics/Logo.png" alt="logo">-->
        <!--</div>-->
        <a v-if="windowWidth > 1300 || $store.state.authenticationPage"
            href="https://canada-az-iran.com/" class="app-header-section clearfix" id="header-logo" target="_blank">
            <img width="70" height="70" src="../assets/appIcons/Pics/Logo.png" alt="logo">
        </a>
        <div class="app-header-section"
             v-if="!$store.state.authenticationPage"
             id="header-content">
            <div id="header-content-search-section">
                <div id="search-input-content">
                    <div>
                        <a id="search-icon" v-on:click="(e)=>searchRequest(e,'button')">
                            <img width="17" height="17" src="../assets/appIcons/Icon/Search.png" alt="search-icon">
                        </a>
                    </div>
                    <div>
                        <input  v-on:keydown="(e)=>searchRequest(e,'input')" v-model="requested" type="text" id="search-input" placeholder="جستجو در مطالب سایت ...">
                    </div>
                </div>
            </div>
            <div id="header-content-nav-section">
                <ul v-if="categories"  style="padding: 15px 0 0 0;margin: 0">
                    <li  v-for="category in categories" :key="category">
                        <span class="header-content-nav-section-text-content" v-on:click="$router.push('/category-view/'+category.slug)">
                           {{category.name}}
                       </span>
                        <span class="header-content-nav-section-icon-content">
                         <img class="arrowDown" width="7" height="5" src="../assets/appIcons/Icon/Filled/ArrowDown.png"
                              alt="icon">
                           <img class="arrowUp" width="7" height="5" src="../assets/appIcons/Icon/Filled/ArrowUp.png"
                                alt="icon">
                       </span>
                        <div class="space"></div>
                        <div class="navigation-menu" v-if="category.subcategories">
                            <ul>
                                <!--style="background-color: green"0020-->
                                <li>
                                    <div v-for="subcategory in category.subcategories" v-on:click="$router.push('/category-view/' + subcategory.slug)"
                                         class="navigation-menu-text-content" :key="subcategory">
                                        <div class="navigation-menu-icon-content">
                                            <img class="arrow" width="12" height="7"
                                                 src="../assets/appIcons/Icon/Filled/Arrow.png" alt="">
                                        </div>
                                        {{subcategory.name}}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li v-on:click="$router.push('/about-us')">
                       <span class="header-content-nav-section-text-content">
                           درباره ما
                       </span>
                    </li>
                </ul>
                <ul v-else>
                    <li v-on:click="$router.push('/about-us')">
                       <span class="header-content-nav-section-text-content">
                           درباره ما
                       </span>
                    </li>
                </ul>
            </div>
        </div>

        <div class="app-header-section clearfix" id="users-login-register-menu">
            <ul v-if="$store.state.loginStatus && $store.state.preliminaryReview">
                <li class="notifications-icon-container" v-on:click="$store.state.notificationDetails.show = true">
                    <img  v-bind:class="{ 'bell' : $store.state.notificationDetails.unreadMessagesCount > 0 }"  width="24" height="24" id="notification-icon" src="../assets/new/New/Icon/Notifs.png" alt="">
                    <span v-if="$store.state.notificationDetails.unreadMessagesCount > 0" class="new-notifications-count">{{$store.state.notificationDetails.unreadMessagesCount}}</span>
                </li>
                <li>
                    <a id="header-button" v-on:click="$router.push('/user-panel')">
                        پنل کاربری
                    </a>
                </li>
            </ul>
            <ul v-else-if="$store.state.preliminaryReview">
                <li>
                    <a id="login" v-on:click="$router.push('/user-signin')">
                        ورود
                    </a>
                </li>
                <li>
                    <a id="register" v-on:click="$router.push('/user-signup')">
                        ثبت نام
                    </a>
                </li>
            </ul>
        </div>
        <SlideBarNavigation :categories="categories" v-if="!$store.state.authenticationPage"/>
    </div>

</template>

<script>
    import SlideBarNavigation from '../components/SlideBarNavigation'
    export default {
        name: "AppHeader",
        components: {
            SlideBarNavigation,
        },
        data() {
            return {
                windowWidth: window.innerWidth,
                loginStatus: 'false',
                showNotification: false,
                requested:null,
                running : false
            }
        },
        props: {
            categories:Object
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
        },
        beforeMount() {
            this.preFunctions()
        },
        methods: {
            searchRequest(e,type){
                if(type === 'input'){
                    if (e.code === "Enter") {
                        this.running = true;
                    }
                }else{
                    this.running = true;
                }
                if (this.running) {
                    this.running = false;
                    let checkSpace = this.requested.replace(/\s/g, "");
                    if(checkSpace !== ""){
                        this.$router.push('/search-results/'+this.requested)
                    }
                    this.requested = null;
                }

            },
            onResize() {
                this.windowWidth = window.innerWidth
            },
            preFunctions() {
                //document.getElementById("mainSidenav").style.width = "0";
            },
        },
    }
</script>

<style lang="scss">
    .notifications-icon-container {
        position: relative;
        cursor: pointer;
    }

    .new-notifications-count {
        color: red;
        position: absolute;
        top: 5px;
        right: -8px;
    }

    #register {
        width: 80px;
        height: 38px;
        padding: 7px 18px 9px;
        border-radius: 10px;
        background-color: #ffffff;
        color: #162336;
    }

    #notification-icon {
        margin-left: 15px;
    }

    .search-mobile-input-content {
        position: absolute;
        top: 10px;
        right: 50px;
        margin-right: 15px;
    }
    @media (max-width: 390px) {
        .search-mobile-input-content {
            margin-right: -5px;
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: 0.05s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }

    textarea:focus, input:focus {
        outline: none;
    }

    #search-input-content {
        display: flex;
        position: relative;
        width: 369px;
        height: 40px;
        float: right;
        border-radius: 10px;
        background-color: rgb(33, 46, 64) !important;
        color: white;
    }

    #search-input-content > div {
        width: 40px;
        height: 40px;
        position: relative;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }

    #search-input-content > div:nth-child(2) {
        display: inline-block;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    #search-input {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        border: none;
        background-color: rgb(33, 46, 64) !important;
        color: white !important;
        text-align: right;
    }

    #search-icon {
        position: absolute;
        top: 10px;
        left: 10px;
    }

    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: white;
        opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: white;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: white;
    }

    #open-nav-btn-icon {
        float: right;
        position: relative;
        right: 0;
        color: white;
    }

    #app-header {
        width: 100%;
        min-height: 110px;
        height: max-content;
        margin: 0 0 10px;
        padding: 10px 0;
        background-color: #162336;
    }

    .navigation-menu-icon-content {
        display: none;
    }

    .arrow {
        position: absolute;
        top: 0%;
        bottom: 0%;
        margin-top: auto;
        margin-bottom: auto;
        right: 0;

    }

    .navigation-menu-text-content {
        /*background-color: cadetblue;0020*/
        position: relative;
        margin: 5px 0;
    }

    .navigation-menu-text-content:hover {
        padding-right: 17px;
        transition: 0.05s;
    }

    .navigation-menu-text-content:hover .navigation-menu-icon-content {
        display: inline-block;
        transition: 0.05s;
    }

    .navigation-menu-icon-content {
        width: 12px;
        /*display: inline-block;*/
        /*background-color: yellow;0020*/
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
    }

    .space {
        height: 15px;
    }

    .navigation-menu > ul {
        list-style-type: none;
        width: 100%;
        height: 100%;
        position: relative;
        margin: 0;
       padding: 0;
    }

    .navigation-menu > ul > li {
        cursor: pointer;
        display: block;
        margin: 15px 0;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
    }

    #header-content-nav-section > ul {
        list-style-type: none;
        width: 100%;
        height: max-content;
        padding: 0;
        text-align: right;
        display: flex;
        flex-wrap: wrap;
        justify-content: right;
        background-color: #162336;
    }

    #header-content-nav-section > ul > li {
        position: relative;
        text-align: right;
        padding: 10px 0 0 0;
        margin: 0 0 0 15px;

    }

    #header-content-nav-section > ul > li:hover .navigation-menu {
        /*transition: all 10s ease;*/
        display: block;
    }

    #header-content-nav-section > ul > li:hover .header-content-nav-section-text-content {
        border-bottom: 2px solid white;
        /*transition: 0.05s;*/
    }

    #header-content-nav-section > ul > li:hover .arrowUp {
        display: inline;
        transition: 0.05s;
    }

    #header-content-nav-section > ul > li:hover .arrowDown {
        display: none;
        transition: 0.05s;
    }

    .navigation-menu {
        /*opacity: 0;*/
        display: none;
        position: absolute;
        background-color: white;
        width: 187px;
        height: auto;
        /*margin: 0 164px 206px 18px;*/
        padding: 0 12px 0 15px;
        right: 0;
        margin: auto;
        border-radius: 10px;
        box-shadow: 0 5px 15px 1px rgba(22, 35, 54, 0.2);
        z-index: 500;
    }

    .arrowUp {
        display: none;
    }

    .header-content-nav-section-text-content {
        height: 80%;
        line-height: 50%;
        font-size: 14px;
        text-align: right;
        width: auto;
        /*background-color: green;0020*/
        padding: 0 6px 6px 5px;
        color: white;
        cursor: pointer;
    }

    .header-content-nav-section-icon-content {
        font-size: 9px;
        padding: 5px;
        color: white;
    }

    #search-input-content > div:nth-child(2) {
        width: 329px;
        height: 40px;
        /*background-color: blue;0020*/
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        position: relative;
    }

    #search-input-content > div:nth-child(2) > input {
        left: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        text-align: right;
        background-color: #ffffff;
        opacity: 0.5;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        /*color: #ffffff;*/

    }

    #header-content > div {
        width: 100%;
        height: max-content;
    }

    #header-content-search-section {
        /*background-color: goldenrod;0020*/
    }

    #header-content-nav-section {
        /*background-color: chocolate;0020*/
    }

    #header-content {
        /*background-color: darkslategrey;0020*/
        height: 100%;
        width: calc(100% - 269px);
    }

    #users-login-register-menu > ul > li {
        display: inline-block;
    }

    #users-login-register-menu > ul {
        margin-top: 11px;
        list-style-type: none;
    }

    #users-login-register-menu {
        float: left;
    }

    #header-logo {
        cursor: pointer;
        width: 70px;
        height: 70px;
        float: right;
        margin: 5px;
        border-radius: 50%;
    }

    .app-header-section {
        height: 100%;
        display: inline-block;
    }

    .app-header-section > ul {
        padding: 0;
    }

    #login {
        width: 25px;
        height: 22px;
        margin: 8px 0 8px 20px;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: justify;
        color: #ffffff;
        cursor: pointer;
    }

    #header-button {
        cursor: pointer;
        width: 80px;
        height: 38px;
        margin: 0 20px 0 0;
        padding: 7px 18px 9px;
        border-radius: 10px;
        background-color: #ffffff;
    }

    #slide-bar-navigation {
        display: none;
    }

    @media (max-width: 1300px) {
        #header-content {
            display: none;
        }
        #header-logo {
            /*display: none;*/
        }
        #login {
            width: 25px;
            height: 22px;
            margin: 8px 0 8px 20px;
            font-size: 14px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: justify;
            color: #ffffff;
            cursor: pointer;
        }
        #header-button {
            width: 80px;
            height: 38px;
            margin: 0 0 0 0;
            padding: 7px 18px 9px;
            border-radius: 10px;
            background-color: #ffffff;
        }
    }

    #app-header {
        position: relative;
        padding: 10px 10px;
        margin: auto;
    }

    /***********/

    .bell {
        -webkit-animation: ring 4s .7s ease-in-out infinite;
        -webkit-transform-origin: 50% 4px;
        -moz-animation: ring 4s .7s ease-in-out infinite;
        -moz-transform-origin: 50% 4px;
        animation: ring 4s .7s ease-in-out infinite;
        transform-origin: 50% 4px;
    }

    @-webkit-keyframes ring {
        0% {
            -webkit-transform: rotateZ(0);
        }
        1% {
            -webkit-transform: rotateZ(30deg);
        }
        3% {
            -webkit-transform: rotateZ(-28deg);
        }
        5% {
            -webkit-transform: rotateZ(34deg);
        }
        7% {
            -webkit-transform: rotateZ(-32deg);
        }
        9% {
            -webkit-transform: rotateZ(30deg);
        }
        11% {
            -webkit-transform: rotateZ(-28deg);
        }
        13% {
            -webkit-transform: rotateZ(26deg);
        }
        15% {
            -webkit-transform: rotateZ(-24deg);
        }
        17% {
            -webkit-transform: rotateZ(22deg);
        }
        19% {
            -webkit-transform: rotateZ(-20deg);
        }
        21% {
            -webkit-transform: rotateZ(18deg);
        }
        23% {
            -webkit-transform: rotateZ(-16deg);
        }
        25% {
            -webkit-transform: rotateZ(14deg);
        }
        27% {
            -webkit-transform: rotateZ(-12deg);
        }
        29% {
            -webkit-transform: rotateZ(10deg);
        }
        31% {
            -webkit-transform: rotateZ(-8deg);
        }
        33% {
            -webkit-transform: rotateZ(6deg);
        }
        35% {
            -webkit-transform: rotateZ(-4deg);
        }
        37% {
            -webkit-transform: rotateZ(2deg);
        }
        39% {
            -webkit-transform: rotateZ(-1deg);
        }
        41% {
            -webkit-transform: rotateZ(1deg);
        }

        43% {
            -webkit-transform: rotateZ(0);
        }
        100% {
            -webkit-transform: rotateZ(0);
        }
    }

    @-moz-keyframes ring {
        0% {
            -moz-transform: rotate(0);
        }
        1% {
            -moz-transform: rotate(30deg);
        }
        3% {
            -moz-transform: rotate(-28deg);
        }
        5% {
            -moz-transform: rotate(34deg);
        }
        7% {
            -moz-transform: rotate(-32deg);
        }
        9% {
            -moz-transform: rotate(30deg);
        }
        11% {
            -moz-transform: rotate(-28deg);
        }
        13% {
            -moz-transform: rotate(26deg);
        }
        15% {
            -moz-transform: rotate(-24deg);
        }
        17% {
            -moz-transform: rotate(22deg);
        }
        19% {
            -moz-transform: rotate(-20deg);
        }
        21% {
            -moz-transform: rotate(18deg);
        }
        23% {
            -moz-transform: rotate(-16deg);
        }
        25% {
            -moz-transform: rotate(14deg);
        }
        27% {
            -moz-transform: rotate(-12deg);
        }
        29% {
            -moz-transform: rotate(10deg);
        }
        31% {
            -moz-transform: rotate(-8deg);
        }
        33% {
            -moz-transform: rotate(6deg);
        }
        35% {
            -moz-transform: rotate(-4deg);
        }
        37% {
            -moz-transform: rotate(2deg);
        }
        39% {
            -moz-transform: rotate(-1deg);
        }
        41% {
            -moz-transform: rotate(1deg);
        }

        43% {
            -moz-transform: rotate(0);
        }
        100% {
            -moz-transform: rotate(0);
        }
    }

    @keyframes ring {
        0% {
            transform: rotate(0);
        }
        1% {
            transform: rotate(30deg);
        }
        3% {
            transform: rotate(-28deg);
        }
        5% {
            transform: rotate(34deg);
        }
        7% {
            transform: rotate(-32deg);
        }
        9% {
            transform: rotate(30deg);
        }
        11% {
            transform: rotate(-28deg);
        }
        13% {
            transform: rotate(26deg);
        }
        15% {
            transform: rotate(-24deg);
        }
        17% {
            transform: rotate(22deg);
        }
        19% {
            transform: rotate(-20deg);
        }
        21% {
            transform: rotate(18deg);
        }
        23% {
            transform: rotate(-16deg);
        }
        25% {
            transform: rotate(14deg);
        }
        27% {
            transform: rotate(-12deg);
        }
        29% {
            transform: rotate(10deg);
        }
        31% {
            transform: rotate(-8deg);
        }
        33% {
            transform: rotate(6deg);
        }
        35% {
            transform: rotate(-4deg);
        }
        37% {
            transform: rotate(2deg);
        }
        39% {
            transform: rotate(-1deg);
        }
        41% {
            transform: rotate(1deg);
        }

        43% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(0);
        }
    }


</style>